import React, { useMemo } from 'react';
import { IconsEnum } from 'components/Icons';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import { miSport } from 'features/live/liveNav/utility';
import { SportManifestazioneFallback } from 'features/sport/components/sportManifestazioneFallback';
import { useTranslation } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';
import { ScommesseEmptyProps } from 'components/scommessaFallback';
import styles from './ScommesseFallback.module.scss';
import { isServerSide } from 'utility/constant';
import classNames from 'classnames';

export const EmptySport = ({ isVisible, hasFilter, hasRedirect, resetFilter }: ScommesseEmptyProps) => {
  const { t } = useTranslation();
  const isCarrelloOpen = useTypedSelector(selectIsOpenCarrello);

  let button: any | undefined = useMemo(() => {
    if (hasFilter) {
      return {
        text: t('reset-filtri-scommesse'),
        action: resetFilter,
      };
    } else if (hasRedirect) {
      return {
        link: miSport.slug,
        text: t('cta-top-sport'),
      };
    }
    return undefined;
  }, [hasFilter, hasRedirect, t, resetFilter]);

  return (
    <SportManifestazioneFallback
      className={classNames(styles.empty, { [styles.hidden]: isServerSide || !isVisible })}
      text={t(hasFilter ? 'empty-filters-settings' : 'empty-sport-avvenimento')}
      icon={hasFilter ? IconsEnum.SEARCH_OFF : undefined}
      button={button}
      haveRightMargin={isCarrelloOpen ? false : true}
    />
  );
};